export default __webpack_public_path__ + "static/media/dongle_face.153841d4.gif";